import { gql } from '@apollo/client';

export const UPDATE_AFFILIATION = gql`
  mutation updateAffiliations($input: UpdateAffiliationsInput!) {
    updateAffiliations(input: $input) {
      account {
        id
        type
      }
      incompleteAffiliations {
        user {
          id
          firstName
          middleName
          lastName
          entityName
        }
        type
        incompleteFields
      }
    }
  }
`;
